(() => {
  // Check for "?discount=Save15" in the current URL
  function hasSave15Discount() {
    return window.location.search.includes('discount=Save15');
  }

  // Convert "Rs.4,085.00" → 4085.00
  function parsePrice(text) {
    if (!text) return NaN;
    return parseFloat(
      text.replace(/\s/g, '')
          .replace(/^Rs\.?/i, '')
          .replace(/,/g, '')
    );
  }

  // Format price as PKR with commas, no decimals
  function formatPKR(n) {
    return Math.round(n).toLocaleString('en-PK');
  }

  // Apply 15% discount and update DOM
  function applyDiscount() {
    const discountedPriceEl = document.getElementById('discounted-price');
    const save15BadgeEl = document.getElementById('save15-badge');
    const salePriceEl = document.querySelector('.price-item--sale');

    if (!discountedPriceEl || !salePriceEl) return false;

    const salePrice = parsePrice(salePriceEl.innerText);
    if (isNaN(salePrice) || salePrice <= 0) return false;

    const newPrice = salePrice * 0.9;

    discountedPriceEl.innerHTML = `<bdi><span class="price__prefix">Rs.</span>${formatPKR(newPrice)}</bdi>`;
    discountedPriceEl.parentElement.style.display = 'block';
    if (save15BadgeEl) save15BadgeEl.style.display = 'inline-block';
    return true;
  }

  // Run when DOM is ready
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Retry applying discount in case prices are rendered late
  function waitForPriceAndApply() {
    if (applyDiscount()) return;
    const obs = new MutationObserver(() => {
      if (applyDiscount()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    setTimeout(() => obs.disconnect(), 8000); // stop after 8 seconds
  }

  // Main
  onReady(() => {
    if (hasSave15Discount()) {
      waitForPriceAndApply();
    }
  });
})();

// Drop-in replacement: paste this anywhere (no other helpers required)
(function () {
  // Detect ?discount=Save15 (case-insensitive, exact match on the parameter)
  function hasSave15() {
    return /(?:\?|&)discount=save15(?:&|$)/i.test(window.location.search);
  }

  function toggleDiscountedCartPrices() {
    const showDiscountEls = document.querySelectorAll('.show-if-discount');
    const hideDiscountEls = document.querySelectorAll('.show-if-no-discount');
    const on = hasSave15();

    // If you want to preserve original display type, you can set data-display on elements
    showDiscountEls.forEach(el => {
      const d = el.dataset.display || 'block';
      el.style.display = on ? d : 'none';
    });
    hideDiscountEls.forEach(el => {
      const d = el.dataset.display || 'block';
      el.style.display = on ? 'none' : d;
    });
  }

  // Run now (if DOM is ready) and again as late-rendered nodes appear
  function runWithObserver() {
    toggleDiscountedCartPrices();

    // Retry while sections/ajax load new content
    const obs = new MutationObserver(() => {
      // Only re-run if any target class exists/changes
      if (document.querySelector('.show-if-discount, .show-if-no-discount')) {
        toggleDiscountedCartPrices();
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, attributes: false, characterData: false });

    // Stop observing after 8s to avoid running forever
    setTimeout(() => obs.disconnect(), 8000);
  }

  if (document.readyState !== 'loading') runWithObserver();
  else document.addEventListener('DOMContentLoaded', runWithObserver);

  // Shopify sections often re-render parts of the page
  document.addEventListener('shopify:section:load', runWithObserver);
  document.addEventListener('shopify:section:select', runWithObserver);
  document.addEventListener('shopify:section:deselect', runWithObserver);

  // If your theme uses Turbo/InstantClick-like navigation, also listen to popstate
  window.addEventListener('popstate', runWithObserver);

  // Expose globally only if you want to call it manually elsewhere
  window.toggleDiscountedCartPrices = toggleDiscountedCartPrices;
})();
